import React, { useState } from "react"
import "./css/app.css"
import bgpatterndesktop from "./images/bpd.svg"
import illustrationbox1 from "./images/ibd.svg"
import illustrationwoman from "./images/iwod.svg"
import Questions from "./Questions"
import data from "./question-answer"
function App() {
  const [click, setClick] = useState([false, false, false, false, false])

  function handleSetClick(index) {
    setClick((prev) => {
      console.log(prev)
      return prev.map((element, key) => {
        if (key == index) return true
        return false
      })
    })
  }

  return (
    <main className="main">
      <div className="box">
        <div className="background-images"></div>
        <img
          src={illustrationbox1}
          className="illusion-box"
          alt="background-img"
        ></img>
        {/* question box */}
        <div className="question-container">
          <h2>FAQ</h2>
          {click &&
            data.map((element, key) => {
              return (
                <Questions
                  question={element.question}
                  answer={element.answer}
                  click={click}
                  handleSetClick={handleSetClick}
                  index={key}
                />
              )
            })}
        </div>
      </div>
    </main>
  )
}

export default App
